import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpBackend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
    .use(HttpBackend) // lädt die JSON Dateien
    .use(LanguageDetector) // erkennt Browser Sprache automatisch
    .use(initReactI18next)
    .init({
        fallbackLng: "de",
        supportedLngs: ["de", "en"],
        debug: false,

        interpolation: {
            escapeValue: false
        },

        backend: {
            loadPath: "/i18n/{{lng}}.json"
        }
    });

export default i18n;
